/* eslint-disable */
// import libs
import React from 'react';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Button from '@material-ui/core/Button';

// import css
import styles from './TableHeader.css';

const TableHeader = props => {
  const {
    headerTxt,
    keyMap,
    enableFilterRow,
    enableFilter,
    filterFunction,
    filterPopOverComponent = null,
    showFilter = false,
    sortOrder,
    sortColumn,
    headerEnrollTable,
  } = props;
  const disabled = !enableFilter;
  return (
    <React.Fragment>
      <div
        className={
          enableFilterRow
            ? styles.tableHeaderWithFilterRow
            : styles.tableHeaderWithOutFilterRow
        }
      >
        {/* added css for  show the empty column if headerTxt is '.' then show blank column */}
        <div className={ (headerTxt) && (headerTxt.length === 1) && (headerTxt.charAt(0) === '.') ? `${styles.text} ${styles.emptyHeaderColumn}` : styles.text}>
          {headerTxt}

          {sortColumn && sortColumn.key === keyMap && sortOrder === 'ascend' && (
            <span>
              <ExpandLess />
            </span>
          )}
          {sortColumn && sortColumn.key === keyMap && sortOrder === 'descend' && (
            <span>
              <ExpandMore />
            </span>
          )}
        </div>
        {enableFilterRow && (
          <div className={styles.filter}>
            <Button
              variant="outlined"
              className={
                disabled
                  ? styles.filterButtonDisable
                  : styles.filterButtonEnable
              }
              onClick={e => {
                e.stopPropagation();
                filterFunction();
              }}
              disabled={disabled}
            >
              FILTER
            </Button>
            {filterPopOverComponent && (
              <div
                className={styles.filterComponent}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {showFilter && filterPopOverComponent}
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/TableHeader/TableHeader.jsx